<template>
  <dict-select
    :value="value"
    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
    url="/sys/common/dict/system"
    :body="{ dictType: 'tskType' }"
    :size="size"
    :disabled="disabled"
    clearable
    filterable
    @loaded="loaded"
    @change="change"
  />
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    loaded(val) {
      if (!val?.length || val.length > 1) return
      const { value } = val[0]
      if (!this.value) {
        this.$emit('input', value)
        this.$emit('update:value', value)
      }
    },
    change(val) {
      this.$emit('change', val)
      this.$emit('input', val)
      this.$emit('update:value', val)
    },
  },
}
</script>
